<script lang="ts">  
  import type { Activity } from "./types";
  import { formatTimeString } from "./utils";

  export let activities: Activity[];
  export let showTitle: boolean = false;
</script>

<div
  class="min-w-0 rounded-xl border border-white/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.045)_0%,rgba(255,255,255,0.02)_100%)] p-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.035)] sm:p-6"
>
  {#if showTitle}
    <h3
      class="text-[1.125rem] font-bold text-white mb-4 uppercase tracking-[0.5px]"
    >
      Recent Sync Activity
    </h3>
  {:else}
    <h3
      class="text-[1.125rem] font-bold text-white mb-4 uppercase tracking-[0.5px]"
    >
      Sync Activity
    </h3>
  {/if}
  <div
    class="max-h-[300px] overflow-y-auto thin-scrollbar"
    class:max-h-[500px]={showTitle}
  >
    {#each activities as activity}
      <div
        class="flex min-w-0 gap-4 py-3 px-4 mb-2 bg-black/20 border-l-[3px] rounded-md text-sm transition-all hover:bg-black/30 hover:translate-x-[2px]"
        class:border-l-green-500={activity.type === "success"}
        class:border-l-red-500={activity.type === "error"}
      >
        <span
          class="text-white/60 font-semibold font-['Courier_New',monospace] shrink-0 text-xs"
        >
          {formatTimeString(activity.timestamp)}
        </span>
        <span class="min-w-0 flex-1 break-words text-white/90">{activity.message}</span>
      </div>
    {:else}
      <div class="flex flex-col items-center justify-center py-12 text-center">
        <div class="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white/[0.06]">
          <svg class="h-6 w-6 text-white/60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="text-base text-white/90">No recent activity</div>
        <div class="mt-1 text-sm text-white/40">Sync activities will appear here once available.</div>
      </div>
    {/each}
  </div>
</div>
